var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 16 / icon_location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M13.0371 5.45506C13.6776 8.72697 10.0045 12.515 8.08785 14C6.12271 12.515 2.46508 8.74837 3.06582 5.45506C3.82455 1.29567 7.21445 1 8.08785 1C8.96124 1 12.2365 1.36517 13.0371 5.45506Z",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 8.05515,
    cy: 6.05564,
    r: 1.88889,
    fill: "white",
    stroke: "#E30031",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.1d8261c38c9fd59ae7e5a52c3694b6a6.svg";
export { ForwardRef as ReactComponent };